<!-- Body -->
<div class="horizontal-content">

    <!-- Left Content -->
    <ng-content select="#left"></ng-content>

    <!-- Tab Content -->
    <div class="flex-content"
        sytle="flex: 1;">

        <!-- Header Row -->
        <div class="headers flexRow">

            <!-- Available Fields Header -->
            <field-search class="fieldsAvailable"
                (search)="applySearch($event)"></field-search>

            <!-- Draggable Headers -->
            <div class="fieldsSelected flexRow">

                <!-- Show in Results Header -->
                <h5 class="fieldWidth"
                    [ngStyle]="{'width': 'calc(50% - ' + diffX + 'px)'}">
                    Show in Results
                </h5>

                <!-- Use as Filters Header -->
                <h5 class="fieldWidth"
                    style="margin-left: 16px;"
                    [ngStyle]="{'width': 'calc(50% + ' + diffX + 'px)'}">
                    Use as Filters
                </h5>
            </div>
        </div>

        <!-- Fields boxes -->
        <div class="flexRow"
            style="flex-grow: 1;max-height: calc(100% - 100px)">

            <!-- Fields Selector -->
            <div class="fieldsAvailable fieldsContainer">
                <virtualized-table [data]="tableData"
                    [columns]="virtualizedTableColumns"
                    [draggableIdentifiers]="['field']"
                    [draggableConnectedLists]="[shownFieldsList, filterFieldsList]"
                    [cellTemplate]="rowTemplate"
                    (fieldDrop)="fieldDrop($event)"
                    [paddingLeftPerLevel]="30"
                    width="100%"
                    height="100%"
                    style="height: 100%; width: 100%"></virtualized-table>
            </div>

            <!-- Draggable Fields -->
            <div class="fieldsSelected flexRow"
                (mousemove)="dividerMove($event)"
                (mouseleave)="dividerStop()"
                (mouseup)="dividerStop()">

                <!-- Show in Results -->
                <div class="fieldWidth"
                    [ngStyle]="{'width': 'calc(50% - 8px - ' + diffX + 'px)'}">

                    <!-- Field Table -->
                    <mat-table id="#cdkDropListShowInResults"
                        [dataSource]="shownFieldTableData"
                        class="fieldsContainer"
                        style="height: 100%"
                        cdkDropList
                        [cdkDropListData]="shownFields"
                        #shownFieldsList="cdkDropList"
                        [cdkDropListConnectedTo]="[filterFieldsList, virtualizedDropList]"
                        (cdkDropListDropped)="fieldDrop($event)">

                        <!-- Field Column -->
                        <ng-container matColumnDef='field'>
                            <mat-header-cell *matHeaderCellDef
                                class="fieldPadding"
                                translate>
                                Field
                            </mat-header-cell>
                            <mat-cell *matCellDef="let field"
                                class="fieldPadding">
                                <data-query-field-label [field]="field"
                                    style="width: 100%;"></data-query-field-label>
                            </mat-cell>
                        </ng-container>

                        <!-- Row definitions -->
                        <!--<mat-header-row *matHeaderRowDef="['field']"></mat-header-row>-->
                        <mat-row *matRowDef="let row; let i = dataIndex; columns: ['field'];"
                            matRipple
                            tabindex="0"
                            style="cursor: pointer"
                            cdkDrag
                            [cdkDragData]="row"
                            id="shownFieldRow{{i}}"></mat-row>
                    </mat-table>
                </div>

                <!-- Divider -->
                <div class="draggableDivider"
                    (mousedown)="dividerClick($event); $event.stopPropagation();">
                    <img src="./assets/images/icons/Arrowhead-Left.png"
                        class="leftArrow">
                    <img src="./assets/images/icons/Arrowhead-Left.png"
                        class="rightArrow">
                </div>

                <!-- Use as Filters -->
                <div class="fieldWidth"
                    [ngStyle]="{'width': 'calc(50% - 8px + ' + diffX + 'px)'}">

                    <!-- Field Table -->
                    <mat-table [dataSource]="filterFieldTableData"
                        class="fieldsContainer"
                        style="height: 100%"
                        cdkDropList
                        [cdkDropListData]="filterFields"
                        #filterFieldsList="cdkDropList"
                        [cdkDropListConnectedTo]="[shownFieldsList, virtualizedDropList]"
                        (cdkDropListDropped)="fieldDrop($event)">

                        <!-- Field Column -->
                        <ng-container matColumnDef='field'>
                            <mat-header-cell *matHeaderCellDef
                                class="fieldPadding"
                                translate>
                                Field
                            </mat-header-cell>
                            <mat-cell *matCellDef="let field"
                                class="fieldPadding">
                                <data-query-field-label [field]="field"
                                    style="width: 100%;"></data-query-field-label>
                            </mat-cell>
                        </ng-container>

                        <!-- Row definitions -->
                        <!--<mat-header-row *matHeaderRowDef="['field']"></mat-header-row>-->
                        <mat-row *matRowDef="let row; let i = dataIndex; columns: ['field'];"
                            matRipple
                            tabindex="0"
                            style="cursor: pointer"
                            cdkDrag
                            [cdkDragData]="row"
                            id="filterFieldRow{{i}}"></mat-row>
                    </mat-table>
                </div>
            </div>
        </div>

        <!-- Hints -->
        <div class="instructionalText">

            <!-- Available Fields Hint -->
            <div class="fieldsAvailable">
                Drag field to the Show in Results box to add columns to the Results view
                Drag Fields to the Use in Filters box to use them when filtering the data
            </div>

            <!-- Draggable Hints -->
            <div class="fieldsSelected">
                Drag fields up or down to change the order in which they display in Results
            </div>
        </div>
    </div>

    <!-- Right Content -->
    <ng-content select="#right"></ng-content>
</div>

<!-- Footer -->
<div class="flex-footer">

    <!-- Left Buttons -->
    <div class="flex-footer-left">
        <ng-content select="#leftFooter"></ng-content>
        <data-query-queries-button *ngIf="!simpleMode"></data-query-queries-button>
        <expand-collapse-buttons [expandEmitter]="toggleAllRows"></expand-collapse-buttons>
        <tyl-button image="list.png"
            label="Field List"
            (clickEvent)="fieldList()"></tyl-button>
        <data-query-legend-button></data-query-legend-button>
    </div>

    <!-- Center Buttons -->
    <div class="footerCenter">
        <data-query-preferences-button></data-query-preferences-button>
    </div>

    <!-- Right Buttons -->
    <div class="footerRight">
        <error-prompt [errorList]="simpleValidationErrors"></error-prompt>
        <data-query-maximize-button *ngIf="!simpleMode"></data-query-maximize-button>
        <ng-content select="#rightFooter"></ng-content>
    </div>
</div>

<!-- Row Template -->
<ng-template #rowTemplate
    let-datum="datum"
    let-column="column">

    <!-- Header Row -->
    <ng-container *ngIf="datum.header">

        <!-- More Column -->
        <ng-container *ngIf="column == 'more' && datum.identifier != 'field'">
            <span style="padding-left: 4px"
                translate>More</span>
        </ng-container>

        <!-- Data Column -->
        <ng-container *ngIf="column == 'data'">

            <!-- Field -->
            <span *ngIf="datum.identifier == 'field'">
                <span style="padding-left: 10px"
                    translate>Field</span>
            </span>

            <!-- Category -->
            <span *ngIf="datum.identifier == 'category'">
                <span translate>Category</span>
            </span>

            <!-- Object -->
            <span *ngIf="datum.identifier == 'object'">
                <span translate>Object</span>
            </span>
        </ng-container>
    </ng-container>

    <!-- Data Row -->
    <ng-container *ngIf="!datum.header">

        <!-- More Column -->
        <ng-container *ngIf="column == 'more' && datum.identifier != 'field'">
            <span class="material-icons" [ngClass]="{
					'detail-row-expanded-icon': datum.showChildren,
					'detail-row-collapsed-icon': !datum.showChildren
				}"
                style="padding-left: 12px"></span>
        </ng-container>

        <!-- Data Column -->
        <ng-container *ngIf="column == 'data'">

            <!-- Field -->
            <div *ngIf="datum.identifier == 'field'"
                style="padding-left: 10px">
                <data-query-field-label [field]="datum.data"></data-query-field-label>
            </div>

            <!-- Category -->
            <span *ngIf="datum.identifier == 'category'">
                {{datum.data.DisplayName}}
            </span>

            <!-- Object -->
            <span *ngIf="datum.identifier == 'object'">
                {{datum.data.DisplayName}}
            </span>
        </ng-container>
    </ng-container>
</ng-template>